import { CHAT_DB_SERVER_URL } from "../config/backend-endpoints";

// Authenticated endpoint — backend enforces one application per Asgardeo account.
// Served by chat-database-server: POST /membership-applications stores a
// standalone review record (no subscription/payment linkage).
// Contract: notes/membership-applications.md
const APPLICATIONS_ENDPOINT = `${CHAT_DB_SERVER_URL}/membership-applications`;
const MEMBERSHIP_APPLICATION_ME_ENDPOINT = `${APPLICATIONS_ENDPOINT}/me`;

export const submitMembershipApplication = async (application, accessToken) => {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Authentication is required to submit a membership application");
  }

  const response = await fetch(APPLICATIONS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(application),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.error || `HTTP ${response.status}: ${response.statusText}`
    );
  }

  return await response.json();
};


export const getMyMembershipApplication = async (accessToken) => {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Authentication is required to check membership application status");
  }

  const response = await fetch(MEMBERSHIP_APPLICATION_ME_ENDPOINT, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.error || `HTTP ${response.status}: ${response.statusText}`
    );
  }

  return await response.json();
};
